import { Component } from '@angular/core';
import { ToastService, Toast } from '../toast.service';

interface ToastData {
  message: string;
  type: 'success' | 'error';
}

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
 toast: Toast | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastService.toast$.subscribe((toast) => {
      this.toast = toast;
    });
  }
}
